import React, { useEffect } from "react";
import CardNew from "../CardNews/CardNew";
import { useDispatch, useSelector } from "react-redux";
import { LIMIT, SERVICE } from "constants/global";
import { Pagination } from "components";
import { getNotices } from "features/News/noticeSlice";
import { scroolElement } from "utils/common";
import ErrorDB from "components/ErrorDB";

const TabHotNews = ({
  isActive,
  currentPageNotices,
  setCurrentPageNotices,
}) => {
  const dispatch = useDispatch();

  const { notices, isInLine } = useSelector((state) => state.notice);

  useEffect(() => {
    dispatch(
      getNotices({
        limit: LIMIT,
        service: SERVICE,
        currentPage: currentPageNotices,
      })
    );
  }, []);

  const handleLoadPage = (currentPageNotices) => {
    setCurrentPageNotices(currentPageNotices);
    dispatch(
      getNotices({
        limit: LIMIT,
        service: SERVICE,
        currentPage: currentPageNotices,
      })
    );
    scroolElement(".tabs-content-news", 200);
  };

  return (
    isActive &&
    notices && (
      <div className="tab-panel-news active">
        <div className="bg-grey border-color-black border-form-hidden p-1 p-md-0">
          <div className="p-2 p-md-0">
            <div className="fs-14 fs-sm-13 fw-600 text-center py-1 m-0 m-md-2 border-color-red-light bg-white text-red-light">
              重要なお知らせは、必ずお読みください。
            </div>
          </div>
          { isInLine ? <ErrorDB/> :
          <div>
            {notices &&
              notices.data.map((item) => <CardNew key={item.id} item={item} />)}
          </div>}
        </div>

        {notices?.last_page > 1 && (
          <Pagination
            pages={notices.last_page}
            currentPage={notices.current_page}
            handle={handleLoadPage}
          />
        )}
      </div>
    )
  );
};

export default TabHotNews;
